import {
  Box,
  Button,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from "../../../theme/colorUtils";

export const Root = styled(Box)(() => ({
  position: "sticky",
  top: 0,
  left: 0,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  height: "50px",
  boxSizing: "border-box",
  zIndex: 10,
  boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
  padding: "0 16px",
  "& > div": {
    display: "flex",
    alignItems: "center",
  },
}));

export const SelectButton = styled(Button)(() => ({
  color: "#333",
  fontSize: "0.75rem",
  "& > svg": {
    marginLeft: 16,
  },
}));

export const LogoSection = styled(Stack)(() => ({
  alignItems: "center",
  gap: "8px",
}));

export const PageIndicator = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: "#333",
}));
